/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Constants, Partner } from '../constants';
import { PartnerField } from '../models';
import { PartnerPickerOptions } from '../partner-picker/partner-picker.component';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'partner-leadowner-picker',
  templateUrl: './partner-leadowner-picker.component.html'
})
export class PartnerLeadownerPickerComponent implements OnInit {

  @Input()
  selectedPartner: Partner;

  @Input()
  selectedField: PartnerField;

  @Input()
  fallbackAddresses: Array<string> = [];

  @Input()
  enableFallback: boolean = true;

  @Input()
  enableReset: boolean = false;

  @Output('onPartnerChange')
  onPartnerChange: EventEmitter<Partner> = new EventEmitter<Partner>();

  @Output('onFieldChange')
  onFieldChange: EventEmitter<PartnerField> = new EventEmitter<PartnerField>();

  @Output('onFallbackChange')
  onFallbackChange: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();

  // field drop down component
  ddFields: any[] = [];
  fieldDDSettings: any = {
    singleSelection: true,
    text: 'Select field',
    enableSearchFilter: true,
    badgeShowLimit: 1
  };
  ddField: any;


  loadingFields: boolean = false;
  fields: Array<PartnerField>;
  addingFallback: boolean = false;
  currentFallbackAddress: string = '';
  errorState: boolean = false;

  // Partner control
  partnerOptions: PartnerPickerOptions = {
    selectDefaultWhenOne: true
  };

  constructor(private constants: Constants,
    private partnerService: PartnerService) { }

  ngOnInit() {
    if (this.selectedPartner) {
      this.loadFields();
    }
  }

  changePartner(partner: Partner) {
    if (partner != this.selectedPartner) {
      this.selectedPartner = partner;
      this.loadFields();
      this.onPartnerChange.emit(this.selectedPartner);
    }
  }

  changeField(field: any) {
    this.onFieldChange.emit(this.fields.find(f => { return f.id == field.id }));
  }

  addFallback() {
    if (this.fallbackAddresses.findIndex(fa => { return fa == this.currentFallbackAddress }) < 0) {
      this.fallbackAddresses.push(this.currentFallbackAddress);
      this.addingFallback = false;
      this.currentFallbackAddress = '';
      this.onFallbackChange.emit(this.fallbackAddresses);
    }
  }

  removeFallback(address: string) {
    this.fallbackAddresses.splice(this.fallbackAddresses.findIndex(f => { return f == address }), 1);
    this.onFallbackChange.emit(this.fallbackAddresses);
  }

  resetPartner() {
    this.selectedPartner = null;
    this.selectedField = null;
    this.onPartnerChange.emit(this.selectedPartner);
  }

  private processFields(fields) {
    this.fields = fields.map(f => {
      return {
        id: f.id,
        name: f.name,
        display: f.description,
        type: f.type ? f.type : 'n/a'
      }
    });
    this.ddFields = fields.map(f => {
      return { id: f.id, itemName: f.description };
    });

    this.ddFields.sort((a, b) => {
      if (a.itemName < b.itemName) {
        return -1;
      }
      else {
        return 1;
      }
    });

    if (this.selectedField) {
      this.ddField = [this.ddFields.find(f => { return f.id == this.selectedField.id })];
    }

  }

  private loadFields() {

    if(!this.selectedPartner){
      return;
    }

    if (!this.loadingFields) {
      this.loadingFields = true;
      this.errorState = false;
      this.fields = [];
      this.ddFields = [];
      // hard-coded drift field becuase they don't have fields like SR think of them
      if (this.selectedPartner.name == 'drift') {
        this.processFields([{
          id: '_account_owner',
          name: '_account_owner',
          description: 'Account Owner',
          type: 'number'
        }]);
        this.loadingFields = false;
      }
      else {
        this.partnerService.getFields(this.selectedPartner.name).subscribe(
          (result: any) => {
            this.processFields(result);
            this.loadingFields = false;
          },
          error => {
            this.errorState = true;
            this.loadingFields = false;
          }
        );
      }
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/global/partner-leadowner-picker/partner-leadowner-picker.component.ts